import { render, staticRenderFns } from "./ExtensivImport.vue?vue&type=template&id=09a532bf&scoped=true"
import script from "./ExtensivImport.vue?vue&type=script&lang=js"
export * from "./ExtensivImport.vue?vue&type=script&lang=js"
import style0 from "./ExtensivImport.vue?vue&type=style&index=0&id=09a532bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a532bf",
  null
  
)

export default component.exports